var _circle, _circle2, _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00C8C8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2947_2387",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#00C8C8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2947_2387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 41L7 31L27 6L40 17.5L42 27L38.5 37.5L25.5 41Z",
    fill: "#1CADB5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 12,
    width: 7,
    height: 19,
    fill: "#E9EDF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 12,
    width: 7,
    height: 19,
    fill: "#CDD2E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 14,
    width: 2.5,
    height: 2.5,
    fill: "#7E8596"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 18,
    width: 2.5,
    height: 2.5,
    fill: "#7E8596"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 22,
    width: 2.5,
    height: 2.5,
    fill: "#7E8596"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 26,
    width: 2.5,
    height: 2.5,
    fill: "#7E8596"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 6,
    width: 14,
    height: 25,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 6,
    width: 7,
    height: 25,
    fill: "#E9EDF5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8,
    width: 10,
    height: 3,
    fill: "#CDD2E1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 16,
    width: 10,
    height: 3,
    fill: "#CDD2E1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 10,
    height: 3,
    fill: "#CDD2E1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    width: 10,
    height: 7,
    fill: "#CDD2E1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 10,
    height: 3,
    fill: "#CDD2E1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 8,
    width: 5,
    height: 3,
    fill: "#AFB4C8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 5,
    height: 3,
    fill: "#AFB4C8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 5,
    height: 3,
    fill: "#AFB4C8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 5,
    height: 7,
    fill: "#AFB4C8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 12,
    width: 5,
    height: 3,
    fill: "#AFB4C8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 14,
    width: 2.5,
    height: 2.5,
    fill: "#AFB4C8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 2.5,
    height: 2.5,
    fill: "#AFB4C8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 22,
    width: 2.5,
    height: 2.5,
    fill: "#AFB4C8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 26,
    width: 2.5,
    height: 2.5,
    fill: "#AFB4C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.5d1d9dda363eccc6d569abb01520d70f.svg";
export { ForwardRef as ReactComponent };